/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Notes_TitleInputs */

const nl_release_notes_title = /** @type {(inputs: Release_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is er nieuw?`)
};

/**

* @param {Release_Notes_TitleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const release_notes_title = /** @type {((inputs?: Release_Notes_TitleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Notes_TitleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_release_notes_title(inputs)
});
export { release_notes_title as "release_notes.title" }